import { deleteDiscountCode, IDiscountCode } from "@/api/settings";
import { Delete } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface Props {
    discount: IDiscountCode;
}
export const DiscountDeleteIcon = ({ discount }: Props) => {
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();

    const deleteMutation = useMutation({
        mutationFn: deleteDiscountCode,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-discount-codes"],
            });
        },
    });

    const handleDelete = () => {
        deleteMutation.mutate(discount.id);
        setOpen(false);
    };

    return (
        <>
            <IconButton
                color="error"
                onClick={() => {
                    setOpen(true);
                }}
            >
                <Delete />
            </IconButton>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle id="alert-dialog-title">
                    Delete Discount {discount.code}?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the discount '
                        {discount.code}'?
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button color="error" onClick={handleDelete} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
